module.exports = __webpack_public_path__ + "img/austria-lung-cancer-male.95f826bc.png";